import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Copy } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function DuplicateTrainingDialog({ training, trigger, onDone }) {
  const [open, setOpen] = useState(false);
  const srcDate = (training?.date || "").slice(0, 10);
  const srcTime = training?.date?.includes("T") ? training.date.slice(11, 16) : "";
  const [date, setDate] = useState(srcDate);
  const [time, setTime] = useState(srcTime);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!date) return toast.error("Data richiesta");
    setBusy(true);
    try {
      const { data } = await api.post(`/trainings/${training.id}/duplicate`, { date, time: time || null });
      toast.success(`Duplicato: ${data.title} · ${data.date.replace("T", " ")}`);
      setOpen(false); onDone?.(data);
    } catch (e) { toast.error(e.response?.data?.detail || "Errore duplicazione"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (o) { setDate(srcDate); setTime(srcTime); } }}>
      <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }} className="inline-flex">{trigger}</div>
      <DialogContent className="max-w-md" onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Copy className="w-5 h-5" />Duplica allenamento</DialogTitle>
          <DialogDescription>Copia solo il programma pianificato (gruppo, durata, obiettivo, blocchi). Presenze, lavoro realizzato e stato NON vengono copiati.</DialogDescription>
        </DialogHeader>
        <div className="py-2 space-y-3">
          <div className="text-sm font-semibold">{training?.title}</div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Nuova data</Label><Input data-testid="dup-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} /></div>
            <div><Label>Orario</Label><Input data-testid="dup-time" type="time" value={time} onChange={(e) => setTime(e.target.value)} /></div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
          <Button data-testid="dup-confirm" onClick={submit} disabled={busy} className="bg-black hover:bg-zinc-800">{busy ? "Duplico…" : "Duplica"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
